module.exports = __webpack_public_path__ + "static/media/hypo-logo-nostamp.a0b3e4fa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/hypo-logo-nostamp.svg
// module id = 1203
// module chunks = 0